import { classNames, h, OmiProps } from "omi";

export function NavSection({
  name,
  withBottomMargin = true,
  children,
}: OmiProps<{ name?: string; withBottomMargin?: boolean }>) {
  return (
    <div class={classNames("h-full", { "mb-3": withBottomMargin })}>
      {name && (
        <div class={classNames({ "mb-1": withBottomMargin })}>
          <h3 class="text-sm font-semibold uppercase">{name}</h3>
        </div>
      )}
      {children}
    </div>
  );
}
